import * as React from 'react';

import Currency from './Currency';
import LineHeight from './LineHeight';
import Wrapper from './Wrapper';

const Span = (props) => <span {...props} />;

export { Wrapper, Currency, Span, LineHeight };
